module.exports = __webpack_public_path__ + "static/img/icca_logo.5fd24cb7.png";